"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findOneByCriteria = void 0;
const axios_1 = __importDefault(require("../shared/lib/axios"));
async function findOneByCriteria(criteria) {
    const request = `{
banorte(
    montoSolicitado: ${criteria.montoSolicitado}
    plazo: ${criteria.plazo}
    modelo: ${criteria.modelo}
    enganche: ${criteria.enganche}
    valorFactura: ${criteria.valorFactura}
    powerTrainId: ${criteria.powerTrainId}
    subsidiaryId: ${criteria.subsidiaryId}
    entidadFederativa: ${criteria.entidadFederativa}
    tipoSeguro: ${criteria.tipoSeguro}
    generarTablaPagos: false
    importeCatSegDanio: ${criteria.importeCatSegDanio}
    garantiaExt: ${criteria.garantiaExtendida}
    pagoGarantiaExt: "${criteria.pagoGarantiaExtendida}"
    listaImporteSeguroDano: ${criteria.listaImporteSeguroDano?.length ?? 0 > 0 ? JSON.stringify(criteria.listaImporteSeguroDano) : null}
) {
    mensaje
        resultado {
            tasa
            tipoSeguro
            importeCatSegDanio
            importeCatSegVida
            comisiones
            montoSolicitado
            cat
            pagoMensual
            totalPagar
            registros{
                numAmortizacion
                pagoAmortizacion
                seguroDanos
                seguroVida
                saldoCapital
                abonoCapital
                interesAmortizacion
                saldoFin
            }
        listaSeguroAuto {
            idAseguradora
            paquete
            aseguradora
            descPaquete
            primaTotal
            listaRecibos {
                vigenciaFin
                vigenciaInicial
                primaTotal
            }
        }
    }
}
}`;
    const { data } = await axios_1.default.post("/graphql", { query: request });
    if (data.errors) {
        throw new Error(data.errors[0].message);
    }
    return data.data.banorte;
}
exports.findOneByCriteria = findOneByCriteria;
